import { render, staticRenderFns } from "./CustomerAdvocate.vue?vue&type=template&id=65c3e59a&"
import script from "./CustomerAdvocate.vue?vue&type=script&lang=js&"
export * from "./CustomerAdvocate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports